/* */ 
(function(Buffer, process) {
  'use strict';
  module.exports = {
    order: 100,
    canValidate: function canValidate(file) {
      return !!file.resolved;
    },
    validate: function validate(file) {}
  };
})(require('buffer').Buffer, require('process'));
